module.exports = __webpack_public_path__ + "img/4.7592a50e.jpg";